"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var i = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "UserProfileIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M15.0003 16.25C18.1945 16.25 20.786 13.7305 20.786 10.625C20.786 7.51953 18.1945 5 15.0003 5C11.8061 5 9.2146 7.51953 9.2146 10.625C9.2146 13.7305 11.8061 16.25 15.0003 16.25ZM17.2654 17.13C17.704 16.9951 18.0945 16.875 18.6 16.875C21.5812 16.875 24 19.2266 24 22.125V23.125C24 24.1602 23.1362 25 22.0714 25H7.92857C6.86384 25 6 24.1602 6 23.125V22.125C6 19.2266 8.41875 16.875 11.4 16.875C11.9078 16.875 12.2987 16.9954 12.7375 17.1304C13.2987 17.3032 13.938 17.5 15 17.5C16.0628 17.5 16.7036 17.3029 17.2654 17.13ZM7.92871 22.125V23.125H22.0716V22.125C22.0716 20.2656 20.5126 18.75 18.6001 18.75C18.3947 18.75 18.148 18.8256 17.8262 18.9242C17.2226 19.1091 16.3549 19.375 15.0001 19.375C13.656 19.375 12.7835 19.1092 12.1764 18.9243L12.1764 18.9243C11.8525 18.8256 11.6042 18.75 11.4001 18.75C9.48764 18.75 7.92871 20.2656 7.92871 22.125ZM18.8569 10.625C18.8569 8.55859 17.1252 6.875 14.9997 6.875C12.8743 6.875 11.1426 8.55859 11.1426 10.625C11.1426 12.6914 12.8743 14.375 14.9997 14.375C17.1252 14.375 18.8569 12.6914 18.8569 10.625Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
});

exports.UserProfileIconMedium = i;